export default function contact_animation() {
    const btn = document.querySelector('.contact_form_toggler');

    if (!btn) return;

    const animationClass = 'pulse-animation';
    const animationDuration = 1500;
    const initialDelay = 20000;
    const repeatInterval = 120000;

    const triggerAnimation = () => {
        btn.classList.add(animationClass);

        setTimeout(() => {
            btn.classList.remove(animationClass);
        }, animationDuration);
    };

    setTimeout(() => {
        triggerAnimation();
        setInterval(triggerAnimation, repeatInterval);
    }, initialDelay);
}
